import type { I18nLocale } from '#/i18n/types/I18nLocale';

const donateLinkByLocale = {
  en: 'https://giving.classy.org/campaign/673245/donate',
  pt: '/pt/doacao',
  es: '/es/dona',
} as const;

export function getDonateRoutePath<T extends I18nLocale>(locale: T) {
  return donateLinkByLocale[locale];
}
